<template>
    <section :class="['newsletter', class_list]">
        <div class="container">
            <h2 class="title">{{ trans.newsletter.title }}</h2>
            <p class="subtitle">{{ trans.newsletter.subtitle }}</p>

            <form action="#" @submit.prevent="handleSubmit" class="form">
                <input class="input" type="text" v-model="fields.name" :placeholder="trans.form.name" required />
                <input class="input" type="email" v-model="fields.email" :placeholder="trans.form.email" required />
                <button class="button" type="submit">{{ trans.buttons.register }}</button>
            </form>
            <alert v-if="alert.type" :type="alert.type" :message="alert.message"></alert>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .newsletter {
        padding: 50px 0;

        &.section-newsletter--gray-style {
            background-color: var(--color-gray-light);
        }

        .title {
            font-size: 38px;
            font-weight: bold;
            text-align: center;
            line-height: 1;
            margin-bottom: 32px;
        }

        .subtitle {
            font-size: 21px;
            text-align: center;
            line-height: 1.2;
            color: var(--color-gray-medium);
        }

        .form {
            margin-bottom: 20px;

            .input,
            .button {
                width: 100%;
                outline: none;
                margin-top: 20px;
            }

            .button {
                margin-top: 40px;
            }
        }

        @media (min-width: 768px) {
            padding: 100px 0;

            .form {
                display: flex;
                justify-content: center;
                margin-top: 48px;

                .input,
                .button {
                    max-width: 330px;
                    margin: 0;

                    & + .input,
                    & + .button {
                        margin-left: 16px;
                    }
                }

                .button {
                    max-width: 170px;
                }
            }
        }
    }
</style>

<script>
    import Alert from './AlertForm.vue'

    export default {
        props: ['trans', 'class_list'],

        components: { Alert },

        data() {
            return {
                alert: {
                    type: null,
                    message: null,
                },
                fields: {
                    name: '',
                    email: '',
                    url: window.location.hostname + window.location.pathname,
                },
            }
        },

        methods: {
            handleSubmit() {
                const { name, email } = this.fields

                if (name === '' || email === '') {
                    this.showAlert(this.trans.form.messages.required, 'error')
                    return false
                }

                const url = '/api/newsletter'
                const request = axios.get(url, {
                    params: this.fields,
                })

                request.then(response => {
                    this.resetFormData()
                    this.showAlert(response.data.message, 'success')
                }).catch(error => {
                    console.error(error)
                    this.showAlert(this.trans.form.messages.error, 'error')
                })
            },

            resetFormData() {
                Object.keys(this.fields).map(i => this.fields[i] = '')
            },

            showAlert(message = '', type = null) {
                this.alert = {
                    type,
                    message,
                }
            }
        }
    }
</script>
